var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 0,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 0,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 0,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 1,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 1,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 1,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 1,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 1,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 1,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FF635E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.ac638c6b56a1030f082fbe4fe59a95bb.svg";
export { ForwardRef as ReactComponent };